import { JSX, use, useMemo, Suspense } from 'react'

import type { StackProps } from '@chakra-ui/react'
import { HStack, Stat } from '@chakra-ui/react'


import { HttpBody } from '@/lib/request'

import * as locally from '@/lib/locally.js'

import * as user_model from '@/model/user.js'

import * as user_storage from '@/storage/user.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loading from '@/components/ui/loading.tsx'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Retrieve
(
	props: {
		doc: Promise<HttpBody<user_model.THydratedDocumentType> >

	},

)
:	JSX.Element
{
	let doc = use(props.doc)

	return (
		<HStack
			px="4"
			py="4"
			gap="4"
			borderWidth="1px"
			borderX="0"
			{...props}
		>
			<Stat.Root>
				<Stat.Label>昵称</Stat.Label>
				<Stat.ValueText>{doc.nickname || '无'}</Stat.ValueText>

			</Stat.Root>

			<Stat.Root>
				<Stat.Label>联系电话</Stat.Label>
				<Stat.ValueText>{doc.phone! || '无'}</Stat.ValueText>

			</Stat.Root>

			<Stat.Root>
				<Stat.Label>注册时间</Stat.Label>
				<Stat.ValueText>{locally.date(doc.created, { default: '无' })}</Stat.ValueText>

			</Stat.Root>

		</HStack>

	)

}


export default function
(
	props: StackProps
		& {
			_id: string
		},

)
:	JSX.Element
{
	let doc = useMemo(
		() => user_storage.retrieve(props._id),

		[props._id],

	)


	return (
		<Suspense fallback={<Loading.Default h="12" />}>
			<Retrieve {...props} doc={doc} />

		</Suspense>



	)

}
